import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { FONT_BRIGHTNESS_MAPPING } from "../../theme/src";
import { LINE_HEIGHT, LINE_WIDTH, PIN_SIZE, TIMELINE_FONT_SIZES, } from './constants';
import { Pin } from './Pin';
import { getPinPositionTop, getStatusColor } from './utils';
export const Milestone = (_a) => {
    var { actions, aside, description, direction = 'vertical', label, labelSize = TIMELINE_FONT_SIZES.MEDIUM, status = 'none', statusText } = _a, otherProps = __rest(_a, ["actions", "aside", "description", "direction", "label", "labelSize", "status", "statusText"]);
    return (_jsxs(Wrapper, Object.assign({ as: "li" }, otherProps, { "$direction": direction, children: [_jsx(Pin, { direction: direction, status: status }), _jsxs(Box, { justifyContent: "space-between", children: [_jsx(Box, { display: "block", font: `${labelSize}-semibold`, children: label }), aside && _jsx(Box, { children: aside })] }), statusText && _jsx(StatusLabel, { "$status": status, children: statusText }), description && (_jsx(Box, { font: "body-regular-asphalt", mt: 1, children: description })), actions && _jsx(Box, { mt: 2, children: actions })] })));
};
const Wrapper = styled(Box).attrs(() => ({
    flexDirection: 'column',
    pb: 6,
})) `
  position: relative;
  padding-left: ${({ theme }) => PIN_SIZE + theme.space[3]}px;
  flex-shrink: 0;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    background: ${({ theme }) => FONT_BRIGHTNESS_MAPPING.black[theme.themeVariables.fontBrightness]};
  }

  ${({ $direction, theme }) => $direction === 'horizontal' &&
    `
      padding-top: ${PIN_SIZE + theme.space[3]}px;
      padding-right: ${PIN_SIZE + theme.space[3]}px;
      align-items: center;

      &:before, &:after {
        height: ${LINE_HEIGHT}px;
        top: ${(PIN_SIZE - LINE_HEIGHT) / 2}px;
      }

      &:before {
        width: calc(50% - ${PIN_SIZE / 2}px);
        left: 0;
      }

      &:after {
        left: calc(50%  + ${PIN_SIZE / 2}px);
        right: 0;
      }

      &:first-child:before {
        width: 50%;
        left: calc(50%  + ${PIN_SIZE / 2}px);
      }

      &:last-child:after {
        display: none;
      }

      &:last-child:before {
        width: calc(50% - ${PIN_SIZE / 2}px);
      }
  `}

  ${({ $direction }) => $direction === 'vertical' &&
    `
      &:before {
        width: ${LINE_WIDTH}px;
        bottom: 0;
        left: ${(PIN_SIZE - LINE_WIDTH) / 2}px;
        top: ${PIN_SIZE}px;
      }

      &:first-child:before {
        left: ${getPinPositionTop};
      }

      &:last-child {
        padding-bottom: 0;
      }

      &:first-child:before {
        top: ${getPinPositionTop};
      }

      &:last-child:before {
        height: ${getPinPositionTop};
        bottom: auto;
      }
  `}
`;
const StatusLabel = styled(Box).attrs(({ $status }) => ({
    color: getStatusColor($status),
    mt: 1,
})) ``;
//# sourceMappingURL=Milestone.js.map